import { createContext } from "react";
export var MobileMenuContext = /*#__PURE__*/createContext({
  isLoggedIn: false,
  items: undefined,
  pinToTopItems: undefined,
  essentialsMenu: undefined,
  accountMenu: undefined,
  cartItemsCount: undefined,
  wishlistItemsCount: undefined,
  sourceType: undefined
});